import React from 'react';

import { Trigger } from '../components';

export const ModalBannerTrigger = () => (
  <Trigger shouldNotRenderAt="desktop" modal />
);
